import { StatsigBootstrapProvider } from "@statsig/next";
import { ReactNode } from "react";
import { getStableId } from "@repo/sdk";
import { getStatsigTier } from "../config";

/**
 * Statsig provider that wraps children with StatsigBootstrapProvider.
 * Reads the stable-id cookie server-side and passes it as customIDs.stableID
 * so all client-side events are attributed to the correct experiment bucket.
 * Gracefully handles missing env vars by rendering children without Statsig.
 */
export async function StatsigProvider({ children }: { children: ReactNode }) {
  if (
    !process.env.NEXT_PUBLIC_STATSIG_API_KEY ||
    !process.env.STATSIG_SERVER_SECRET_KEY
  ) {
    // In development/test environments, render children without Statsig
    console.warn(
      "[Statsig] Missing environment keys - rendering without Statsig"
    );
    return <>{children}</>;
  }

  const stableID = await getStableId();
  const user = stableID ? { customIDs: { stableID } } : {};
  const tier = getStatsigTier();

  return (
    <StatsigBootstrapProvider
      user={user}
      clientKey={process.env.NEXT_PUBLIC_STATSIG_API_KEY}
      serverKey={process.env.STATSIG_SERVER_SECRET_KEY}
      clientOptions={{ environment: { tier } }}
      serverOptions={{ environment: { tier } }}
    >
      {children}
    </StatsigBootstrapProvider>
  );
}

export default StatsigProvider;
